"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- SIMPLE PAGINATION : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'SimplePagination',
  group: _definitionhelpers.groupNames.pagination,
  props: {
    currentIndex: {
      type: 'number',
      default: 50
    },
    itemsPerPage: {
      type: 'number',
      default: 50
    },
    totalItems: {
      type: 'number',
      default: 55
    },
    currentPage: {
      type: 'number',
      default: 1
    },
    firstLastButtons: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    handlePrevious: {
      type: 'function',
      default: function _default() {
        return console.log('Previous');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    handleNext: {
      type: 'function',
      default: function _default() {
        return console.log('Next');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    totalItemsDisplay: {
      type: 'string',
      default: "55 total questions"
    }
  }
};
exports.default = _default2;